import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXInquiry implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxInquiryContainer";
    }
    render(){
        // console.log("inquiry");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxInquiryContainer", "firstName", "local_lead_first_name");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxInquiryContainer", "lastName", "local_lead_last_name");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxInquiryContainer", "phone", "local_lead_phone");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxInquiryContainer", "email", "local_lead_email");
    }
}